import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import PageHeader from './PageHeader';
import { APP_STORE_URL } from '../constants';

const ChangelogPage = () => {
    const { getFullTranslation } = useLanguage();
    const t = getFullTranslation('changelogPage');

    return (
        <div>
            <PageHeader title={t.title} subtitle={t.subtitle} />

            <div className="max-w-3xl mx-auto px-6 py-16">
                {/* v1.0.0 */}
                <div className="bg-white rounded-2xl p-8 mb-6 border border-gray-200 relative">
                    <div className="flex items-center justify-between flex-wrap gap-3 mb-4">
                        <div className="flex items-center gap-3">
                            <span className="inline-block bg-emerald-500 text-white px-3 py-1 rounded-full text-xs font-semibold">{t.latest}</span>
                            <h2 className="text-xl font-bold text-gray-900">v1.0.0</h2>
                        </div>
                        <span className="text-gray-400 text-sm">{t.v100Date}</span>
                    </div>

                    <div className="mt-4 space-y-4">
                        <div>
                            <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wide mb-2">{t.newFeatures}</h3>
                            <ul className="space-y-2">
                                {[t.feature1, t.feature2, t.feature3, t.feature4, t.feature5].map((f, i) => (
                                    <li key={i} className="flex items-start gap-2 text-gray-600 text-sm">
                                        <span className="text-orange-500 font-bold">•</span>
                                        <span>{f}</span>
                                        <span className="inline-block bg-emerald-500 text-white px-1.5 py-0.5 rounded text-[10px] font-semibold ml-1">NEW</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div>
                            <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wide mb-2">{t.improvements}</h3>
                            <ul className="space-y-2">
                                {[t.improve1, t.improve2, t.improve3].map((f, i) => (
                                    <li key={i} className="flex items-start gap-2 text-gray-600 text-sm">
                                        <span className="text-orange-500 font-bold">•</span>
                                        <span>{f}</span>
                                        <span className="inline-block bg-blue-500 text-white px-1.5 py-0.5 rounded text-[10px] font-semibold ml-1">IMPROVED</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div>
                            <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wide mb-2">{t.fixes}</h3>
                            <ul className="space-y-2">
                                {[t.fix1, t.fix2, t.fix3].map((f, i) => (
                                    <li key={i} className="flex items-start gap-2 text-gray-600 text-sm">
                                        <span className="text-orange-500 font-bold">•</span>
                                        <span>{f}</span>
                                        <span className="inline-block bg-amber-500 text-white px-1.5 py-0.5 rounded text-[10px] font-semibold ml-1">FIXED</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>

                {/* v0.9.0 */}
                <div className="bg-white rounded-2xl p-8 mb-6 border border-gray-200">
                    <div className="flex items-center justify-between flex-wrap gap-3 mb-4">
                        <div className="flex items-center gap-3">
                            <span className="inline-block bg-orange-500 text-white px-3 py-1 rounded-full text-xs font-semibold">{t.beta}</span>
                            <h2 className="text-xl font-bold text-gray-900">v0.9.0</h2>
                        </div>
                        <span className="text-gray-400 text-sm">{t.v090Date}</span>
                    </div>
                    <div className="mt-4 space-y-4">
                        <div>
                            <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wide mb-2">{t.newFeatures}</h3>
                            <ul className="space-y-2">
                                {[t.beta1, t.beta2, t.beta3, t.beta4].map((f, i) => (
                                    <li key={i} className="flex items-start gap-2 text-gray-600 text-sm">
                                        <span className="text-orange-500 font-bold">•</span>
                                        <span>{f}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div>
                            <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wide mb-2">{t.knownIssues}</h3>
                            <ul className="space-y-2">
                                {[t.issue1, t.issue2].map((f, i) => (
                                    <li key={i} className="flex items-start gap-2 text-gray-600 text-sm">
                                        <span className="text-orange-500 font-bold">•</span>
                                        <span>{f}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>

                {/* CTA */}
                <div className="bg-gradient-to-br from-[#163020] to-[#0f1f15] rounded-3xl p-12 text-center text-white mt-12">
                    <h2 className="text-2xl font-bold mb-3">{t.ctaTitle}</h2>
                    <p className="opacity-80 text-sm mb-6">{t.ctaDesc}</p>
                    <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer"
                        className="inline-flex items-center px-8 py-3.5 bg-orange-500 text-white font-semibold rounded-xl hover:bg-orange-600 transition">{t.ctaButton}</a>
                </div>
            </div>
        </div>
    );
};

export default ChangelogPage;
